(function (window, document) {
  'use strict';

  var PIXEL_ID = 'EFJfGrPewfrKrMchrJ8Rhu';
  var SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
  var sdkRequested = false;
  var pixelInitialized = false;
  var privacyLoadRequested = false;
  var privacyRetryCount = 0;
  var privacyResolutionExpired = false;
  var MAX_PRIVACY_RETRIES = 20;
  var PRIVACY_RETRY_MS = 250;
  var MAX_PENDING_LEADS = 10;
  var measurementConsentState = null;
  var pendingLeadOptions = [];

  function exposeClickReferenceAlias() {
    if (
      !window.location
      || !window.history
      || typeof window.history.replaceState !== 'function'
      || typeof window.URL !== 'function'
    ) return;

    try {
      var url = new window.URL(window.location.href);
      if (url.searchParams.get('oppref')) return;

      var aliasedOppref = (url.searchParams.get('oa_oppref') || '').trim();
      if (!aliasedOppref || aliasedOppref.length > 1024) return;

      // Ads Manager exposes {oppref} as a template value but rejects the
      // reserved query-parameter name itself. The account-level workaround
      // carries the template in oa_oppref; expose it under the SDK's official
      // parameter name before the Pixel queue is initialized or the SDK loads.
      url.searchParams.set('oppref', aliasedOppref);
      url.searchParams.delete('oa_oppref');
      window.history.replaceState(
        window.history.state,
        '',
        url.pathname + url.search + url.hash
      );
    } catch (error) {}
  }

  function installPixelQueue() {
    if (window.oaiq) {
      sdkRequested = true;
      return;
    }

    var queue = function () {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.oaiq = queue;
  }

  function loadPixelSdk() {
    if (sdkRequested) return;
    sdkRequested = true;

    var sdk = document.createElement('script');
    sdk.async = true;
    sdk.src = SDK_URL;

    var firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(sdk, firstScript);
    } else {
      document.head.appendChild(sdk);
    }
  }

  function measurementAllowed() {
    var privacy;
    try {
      privacy = window.Shopify && window.Shopify.customerPrivacy;
    } catch (error) { return null; }
    if (!privacy) return null;
    var marketingAllowed = null;
    var sharingAllowed = null;
    try {
      if (typeof privacy.marketingAllowed === 'function') marketingAllowed = privacy.marketingAllowed();
    } catch (error) {}
    try {
      // Retain the existing compatibility rule when this optional API is absent.
      sharingAllowed = typeof privacy.saleOfDataAllowed !== 'function'
        ? true : privacy.saleOfDataAllowed();
    } catch (error) {}
    if (marketingAllowed === false || sharingAllowed === false) return false;
    if (marketingAllowed === true && sharingAllowed === true) return true;
    return null;
  }

  function clearStoredClickReference() {
    // A denied page must revoke the SDK reference even when we never load the
    // SDK there. Expire only its __oppref cookie, with the SDK's Path=/ scope.
    // Cover host-only and the ancestor domains its domain-selection probe can
    // choose; no probe/new identifier, other cookie, or network request is used.
    var hostname = '';
    var secure = '';
    try {
      hostname = (window.location.hostname || '').toLowerCase();
      secure = window.location.protocol === 'https:' ? '; Secure' : '';
    } catch (error) {}
    var expired = '__oppref=; Path=/; Max-Age=0; SameSite=Lax';
    function expire(domain) {
      try { document.cookie = expired + (domain ? '; Domain=' + domain : '') + secure; } catch (error) {}
    }
    expire('');
    if (!hostname || hostname === 'localhost' || hostname.indexOf(':') !== -1 || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) return;
    var parts = hostname.split('.').filter(Boolean);
    for (var count = 2; count <= parts.length; count++) {
      expire(parts.slice(parts.length - count).join('.'));
    }
  }

  function sendLead(options) {
    window.oaiq(
      'measure',
      'lead_created',
      { type: 'customer_action' },
      options
    );
  }

  function flushPendingLeads() {
    var queued = pendingLeadOptions.slice();
    pendingLeadOptions = [];
    queued.forEach(sendLead);
  }

  function syncMeasurementConsent() {
    var allowed = measurementAllowed();
    measurementConsentState = allowed;
    if (allowed === null) {
      retryPrivacyApi();
      return;
    }
    privacyResolutionExpired = false;
    if (allowed === false) clearStoredClickReference();
    window.oaiq('consent', allowed);
    if (!pixelInitialized) {
      // Resolve Shopify's actual decision before init. The SDK treats false
      // as a real revocation and deletes its stored click reference; queuing
      // a temporary false on every allowed page would erase attribution.
      window.oaiq('init', { pixelId: PIXEL_ID });
      pixelInitialized = true;
    }
    if (allowed) {
      loadPixelSdk();
      flushPendingLeads();
    } else {
      pendingLeadOptions = [];
    }
  }

  function retryPrivacyApi() {
    if (privacyRetryCount >= MAX_PRIVACY_RETRIES) {
      measurementConsentState = null;
      privacyResolutionExpired = true;
      pendingLeadOptions = [];
      return;
    }
    privacyRetryCount += 1;
    window.setTimeout(loadPrivacyApi, PRIVACY_RETRY_MS);
  }

  function loadPrivacyApi() {
    try {
      if (
        window.Shopify
        && window.Shopify.customerPrivacy
        && (typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'
          || typeof window.Shopify.customerPrivacy.saleOfDataAllowed === 'function')
      ) {
        syncMeasurementConsent();
        return;
      }

      if (
        window.Shopify
        && typeof window.Shopify.loadFeatures === 'function'
        && !privacyLoadRequested
      ) {
        privacyLoadRequested = true;
        window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1'
          }
        ], function (error) {
          if (!error) {
            syncMeasurementConsent();
            return;
          }
          privacyLoadRequested = false;
          retryPrivacyApi();
        });
        return;
      }
    } catch (error) {
      // An unavailable/throwing API is not the visitor's rejection.
      measurementConsentState = null;
    }

    retryPrivacyApi();
  }

  function leadEventId(event) {
    var details = event && event.detail ? event.detail : {};
    var inquiryId = typeof details.inquiry_id === 'string'
      ? details.inquiry_id.trim()
      : '';
    return inquiryId.slice(0, 128);
  }

  function measureLead(event) {
    // Skip controlled QA before either sending or queuing a business lead.
    // The publisher restores these exact source/medium values after redirect.
    if (event && event.detail
      && event.detail.utm_source === 'codex_qa' && event.detail.utm_medium === 'qa') return;
    var options = {
      // openXpromo needs aggregate conversion measurement, not user-level
      // personalization based on this conversion event.
      opt_out: true
    };
    var eventId = leadEventId(event);
    if (eventId) options.event_id = eventId;

    if (measurementConsentState === true) {
      sendLead(options);
      return;
    }

    // Shopify can finish a contact-form redirect before its async privacy API
    // has resolved. Hold only that undecided event; never replay a lead after
    // an explicit denial.
    if (
      measurementConsentState === null
      && !privacyResolutionExpired
      && pendingLeadOptions.length < MAX_PENDING_LEADS
    ) {
      pendingLeadOptions.push(options);
    }
  }

  exposeClickReferenceAlias();
  installPixelQueue();

  // While Shopify's decision is unknown, install only our inert queue and
  // listeners. Init and SDK loading wait for that decision; unknown is never
  // permission to measure. Actual denial/revocation still sends false above.

  window.addEventListener('openxpromo:generate_lead', measureLead);
  document.addEventListener('visitorConsentCollected', syncMeasurementConsent);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', loadPrivacyApi);
  loadPrivacyApi();
})(window, document);
